import { useState } from 'react';
import { ContentWrapper } from 'src/components/ContentWrapper';
import { Heading } from 'src/components/Heading';
import { RadioTab } from 'src/components/RadioTab';
import { CallFeedback } from './CallFeedback';
import { SimulationTesting } from './SimulationTesting';
import { StabilityLevel } from 'src/types/stability-level';

enum TrainingCenterTabOption {
  FEEDBACK = 'feedback',
  SIMULATION_TESTING = 'simulation_testing',
}
export const TrainingCenter = () => {
  const [selectedTab, setSelectedTab] = useState<TrainingCenterTabOption>(
    TrainingCenterTabOption.FEEDBACK,
  );
  return (
    <div className="flex-1">
      <Heading
        title="Training Center"
        subtitle="Train your agents to improve their performance"
        className="border-b-0"
        stabilityLevel={StabilityLevel.Experimental}
      />
      <RadioTab
        onChange={(tabValue) => {
          setSelectedTab(tabValue as TrainingCenterTabOption);
        }}
        items={[
          { label: 'Call Feedback', value: TrainingCenterTabOption.FEEDBACK },
          {
            label: 'Simulation Testing',
            value: TrainingCenterTabOption.SIMULATION_TESTING,
          },
        ]}
        className="pl-2"
        value={selectedTab}
      />
      <ContentWrapper>
        {selectedTab === TrainingCenterTabOption.FEEDBACK && <CallFeedback />}
        {selectedTab === TrainingCenterTabOption.SIMULATION_TESTING && (
          <SimulationTesting />
        )}
      </ContentWrapper>
    </div>
  );
};
